module.exports = __webpack_public_path__ + "media/unipod/icon-live-testing-black-fb89855e.svg";